import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CANVAS_DASHBOARD, CANVAS_DASHBOARD_DRIVE_FILES, PRIVACY_POLICY, TERMS_CONDITION } from '../constant/routes';
import { SessionManagerService } from '../services/index';

@Injectable({
  providedIn: 'root',
})
export class UserAuthGuard implements CanActivate {
  constructor(
    private sessionManagerService: SessionManagerService,
    private router: Router,
    private location: Location,
  ) {}
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const redirectionURL = this.location.prepareExternalUrl(this.location.path());
    const driveUrlRoute = redirectionURL.startsWith('/student/drive');
    if (driveUrlRoute && localStorage.getItem('logout') != 'true') {
      localStorage.setItem('redirectionURL', redirectionURL);
      localStorage.setItem('isGoogleDriveLoginAttempt', 'true');
    }
    const { token = '', roleId = '' } = this.sessionManagerService.getTokenAndRole();
    const { mathLevelId = '', matheLevelNo } = this.sessionManagerService.getUserMathLevelId();
    const fileIdAndBFileId = this.sessionManagerService.getFileIdAndBFileId() || {};

    if (location.pathname == PRIVACY_POLICY.URL) {
      return true;
    } else if (location.pathname == TERMS_CONDITION.URL) {
      return true;
    } else if (token && roleId) {
      const lastOpenedFileType: any = localStorage.getItem('LAST_OPENED_FILE');
      const isIntegratedWithGoogle = this.sessionManagerService.getisIntegratedWithGoogle();
      if (mathLevelId && lastOpenedFileType == 'Kiwiwrite') {
        this.router.navigate([`${CANVAS_DASHBOARD.URL}/${matheLevelNo}`], {
          queryParams: fileIdAndBFileId,
        });
      } else if (lastOpenedFileType == 'Google' && isIntegratedWithGoogle == 'true') {
        const userId = this.sessionManagerService.getUserId();
        const googleDriveFileId = this.sessionManagerService.getGoogleFileId()?.googleDriveFileid;
        const driveQuery = `{"ids":["${googleDriveFileId}"],"action":"open","userId":"${userId}","resourceKeys":{}}`;
        this.router.navigate([`${CANVAS_DASHBOARD_DRIVE_FILES.URL}`], {
          queryParams: { state: driveQuery, level: matheLevelNo },
        });
      } else {
        this.router.navigate([`${CANVAS_DASHBOARD.URL}/${matheLevelNo}`], {
          queryParams: fileIdAndBFileId,
        });
      }
      return false;
    }
    return true;
  }
}
